function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3866",
  "data-name": "Rectangle 3866",
  width: 30,
  height: 30,
  rx: 15,
  fill: "#c8c8c8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2631",
  "data-name": "Path 2631",
  d: "M171.7,68.5a5.7,5.7,0,0,0-5.7,5.724c0,3.955,4.08,7.582,5.335,8.542a.588.588,0,0,0,.749,0c1.258-.989,5.3-4.586,5.3-8.542A5.7,5.7,0,0,0,171.7,68.5Zm0,8.09a2.4,2.4,0,1,1,1.7-.7A2.4,2.4,0,0,1,171.7,76.59Z",
  transform: "translate(-157 -60.5)",
  fill: "#fff"
});

function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "location",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.750153be.svg";
export { ForwardRef as ReactComponent };